import React from "react";
import { GetStaticProps } from "next";
import { get_tdk } from "api/server/tdk";
import { getOrigin } from "utils/method";
import CfdLayout from "../index";
import ConvertBuy from "@/components/Pages/Convert/ConvertBuy";
import styles from "./spot.module.scss";

const ConvertSpotPage: React.FC = () => {
  return (
    <CfdLayout>
      <div className={styles.spotConvert}>
        <ConvertBuy embedded />
      </div>
    </CfdLayout>
  );
};

export default ConvertSpotPage;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const resolvedUrl = "/futures/contract/spot";
  const targetLocale = locale || "default";
  const props: { resolvedUrl: string; tdk?: Record<string, unknown> } = { resolvedUrl };

  try {
    const tdkUrl = getOrigin("www") + "/" + targetLocale + resolvedUrl;
    const tdk = await get_tdk({
      params: {
        url: tdkUrl,
        languageType: targetLocale === "zh-CN" ? "cn" : targetLocale === "zh-HK" ? "hk" : targetLocale,
      },
    });
    props.tdk = tdk || {};
  } catch {
    props.tdk = {};
  }

  return {
    props,
    revalidate: 60,
  };
};
